import React from 'react';

import { Map } from 'immutable';
import { Selector, createStructuredSelector } from '@opengov/compose-app/reselect';
import { ReportPage } from './components/ReportPage';
import { selectReportPageProps } from './components/ReportPage/selectors';
import { IReactComponent } from '@opengov/compose-app/types';
import { PageTitle } from './components/PageTitle/PageTitle';

export interface IPageComponentProps<Props> {
  title: string | Selector<unknown, string>;
  selector: Selector<unknown, Props>;
  component: IReactComponent<Props>;
  name?: string;
  trackingName?: string;
}

export function PageComponent<Props>({ title, selector, component: Component }: IPageComponentProps<Props>) {
  const pageSelector = createStructuredSelector({
    pageProps: selectReportPageProps,
    componentProps: selector
  });

  const ConnectedPageComponent = (props: { state: Map<string, unknown> }) => {
    const { pageProps, componentProps } = pageSelector(props.state);
    const pageTitle = typeof title === 'function' ? title(props.state) : title;

    return (
      <ReportPage {...pageProps}>
        <PageTitle title={pageTitle} />
        <Component {...componentProps} />
      </ReportPage>
    );
  };
  ConnectedPageComponent.displayName = 'ConnectedPageComponent';

  return ConnectedPageComponent;
}
